<template>
  <div class="side-bar mt-4">
    <div class="full-content">
      <div class="right-side">
        <router-link to="/admin-home">
          <!-- <svg
            xmlns="http://www.w3.org/2000/svg"
            width="25"
            height="25"
            viewBox="0 0 24 24"
            class="mx-2"
          >
            <path
              fill="currentColor"
              d="M13 9V3h8v6zM3 13V3h8v10zm10 8V11h8v10zM3 21v-6h8v6z"
            />
          </svg> -->
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            viewBox="0 0 24 24"
            class="mx-2"
          >
            <path
              fill="currentColor"
              d="M20 2H4c-1.1 0-1.99.9-1.99 2L2 22l4-4h14c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2m-2 12H6v-2h12zm0-3H6V9h12zm0-3H6V6h12z"
            />
          </svg>
          <span :class="$i18n.locale === 'ar' ? 'ms-2' : 'me-2'">{{
            $t("dashboard.Messages")
          }}</span>
          {{ $store.state.unreadMessage }}
        </router-link>
        <router-link to="/admin-services">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            viewBox="0 0 32 32"
            class="mx-2"
          >
            <path
              fill="currentColor"
              d="M21.5 2.5v1.406a5.6 5.6 0 0 0-2.28.938l-1.032-.97l-1.375 1.47l1 .937a5.7 5.7 0 0 0-.907 2.22H15.5v2h1.406c.146.83.474 1.586.938 2.25l-1.063 1.03l1.44 1.44l1.03-1.064c.664.464 1.42.792 2.25.938V16.5h2v-1.406a5.7 5.7 0 0 0 2.22-.906l.936 1l1.47-1.376l-.97-1.03c.47-.67.79-1.445.938-2.282H29.5v-2h-1.406a5.6 5.6 0 0 0-.938-2.25l.938-.938l-1.407-1.406l-.937.938a5.6 5.6 0 0 0-2.25-.938V2.5zm1 3.313A3.664 3.664 0 0 1 26.188 9.5c0 2.055-1.633 3.688-3.688 3.688s-3.688-1.633-3.688-3.688s1.633-3.688 3.688-3.688zM9.53 11.718l-1.842.75l.718 1.81a6.94 6.94 0 0 0-2.344 2.314l-1.78-.72l-.75 1.845l1.78.718a6.8 6.8 0 0 0-.218 1.656c0 .57.085 1.126.218 1.656l-1.78.72l.75 1.843l1.78-.72a6.9 6.9 0 0 0 2.344 2.345l-.72 1.78l1.845.75l.72-1.78a6.8 6.8 0 0 0 1.656.218c.57 0 1.128-.085 1.656-.218l.72 1.78l1.843-.75l-.72-1.78a6.9 6.9 0 0 0 2.314-2.344l1.81.718l.75-1.843l-1.81-.72c.13-.53.218-1.087.218-1.656c0-.57-.087-1.128-.22-1.657l1.813-.718l-.75-1.845l-1.81.72a6.9 6.9 0 0 0-2.314-2.314l.72-1.81l-1.845-.75l-.717 1.81a7 7 0 0 0-1.657-.217c-.57 0-1.126.086-1.656.218l-.72-1.81zm2.376 3.592c2.663 0 4.78 2.12 4.78 4.782c.002 2.663-2.117 4.812-4.78 4.812a4.806 4.806 0 0 1-4.812-4.812c0-2.663 2.15-4.782 4.812-4.782"
            />
          </svg>
          <span>{{ $t("dashboard.services") }}</span>
        </router-link>
        <router-link to="/admin-types">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            viewBox="0 0 24 24"
            class="mx-2"
          >
            <path
              fill="currentColor"
              fill-rule="evenodd"
              d="M21.25 8.5c0-1.404 0-2.107-.337-2.611a2 2 0 0 0-.552-.552c-.441-.295-1.034-.332-2.115-.336q.005.438.004.91V7.25h1a.75.75 0 0 1 0 1.5h-1v1.5h1a.75.75 0 0 1 0 1.5h-1v1.5h1a.75.75 0 0 1 0 1.5h-1v6.5h-1.5V6c0-1.886 0-2.828-.586-3.414S14.636 2 12.75 2h-2c-1.886 0-2.828 0-3.414.586S6.75 4.114 6.75 6v15.25h-1.5v-6.5h-1a.75.75 0 0 1 0-1.5h1v-1.5h-1a.75.75 0 0 1 0-1.5h1v-1.5h-1a.75.75 0 0 1 0-1.5h1V5.91q-.001-.47.004-.91c-1.081.005-1.674.042-2.115.337a2 2 0 0 0-.552.552C2.25 6.393 2.25 7.096 2.25 8.5v12.75h-.5a.75.75 0 0 0 0 1.5h20a.75.75 0 0 0 0-1.5h-.5zM9 11.75a.75.75 0 0 1 .75-.75h4a.75.75 0 0 1 0 1.5h-4a.75.75 0 0 1-.75-.75m0 3a.75.75 0 0 1 .75-.75h4a.75.75 0 0 1 0 1.5h-4a.75.75 0 0 1-.75-.75m2.75 3.5a.75.75 0 0 1 .75.75v2.25H11V19a.75.75 0 0 1 .75-.75M9 6.25a.75.75 0 0 1 .75-.75h4a.75.75 0 0 1 0 1.5h-4A.75.75 0 0 1 9 6.25m0 3a.75.75 0 0 1 .75-.75h4a.75.75 0 0 1 0 1.5h-4A.75.75 0 0 1 9 9.25"
              clip-rule="evenodd"
            />
          </svg>
          <span>{{ $t("dashboard.types") }}</span>
        </router-link>
        <router-link to="/admin-plans">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            viewBox="0 0 100 100"
            class="mx-2"
          >
            <path
              fill="currentColor"
              d="M1.965 12.5C.88 12.5 0 13.443 0 14.605v70.79c0 1.162.88 2.104 1.965 2.105h96.07c1.085 0 1.965-.943 1.965-2.105v-70.79c0-1.162-.88-2.104-1.965-2.105Zm22.408 4.213h12.385c3.19 1.117 6.48 2.17 9.773 3.135c7.26 2.126 14.43 3.856 20.004 5.056c1.774.382 3.307.687 4.711.957c-.961 1.034-1.904 2.065-2.867 3.094l-1.057 1.129c-6.493-2.033-13.921-4.056-23.474-6.059c-6.74-1.412-13.237-3.964-19.475-7.312m17.08 0h14.453a296 296 0 0 0 11.785 2.814c2.73.588 5.06 1.043 6.784 1.346a59 59 0 0 0 2.091.336c.52.071.951.085.795.09l.006.158a419 419 0 0 0 4.26-4.744h5.332c-4.469 5.16-9.513 10.604-14.564 16.002C62.597 43.184 52.989 53.4 48.97 59.592a10.4 10.4 0 0 1 1.79 5.836c0 1.793-.457 3.484-1.261 4.963c4.097 3.203 7.157 7.856 9.928 12.896h-4.635c-2.384-4.05-4.909-7.543-7.832-9.808a10.41 10.41 0 0 1-9.732 1.949a89 89 0 0 1-3.231 7.86h-4.43c1.527-3.143 2.92-6.369 4.096-9.782c-2.336-1.923-3.83-4.834-3.83-8.078c0-2.752 1.083-5.258 2.836-7.131c-5.91-13.21-16.585-20-28.738-27.215v-4.674c12.892 7.605 25.195 14.839 32.052 29.502a10.35 10.35 0 0 1 10.092.809c4.67-6.914 13.935-16.629 23.397-26.739c1.588-1.697 3.155-3.398 4.73-5.1c-.158-.026-.253-.038-.422-.068a192 192 0 0 1-6.931-1.375c-5.543-1.193-12.683-2.916-19.897-5.029a212 212 0 0 1-5.5-1.695m20.65 0H79.6c-.895 1.004-1.77 1.997-2.702 3.021c-.05-.005-.077-.004-.128-.011a59 59 0 0 1-2.036-.328c-1.697-.299-4.013-.75-6.726-1.334a291 291 0 0 1-5.904-1.348m26.846 0h7.12v4.385c-.042-.003-.082-.012-.124-.012h-.013a1.75 1.75 0 0 0 .013 3.5c.042 0 .082-.009.123-.012v3.524c-.04-.003-.08-.012-.123-.012h-.013a1.75 1.75 0 0 0 .013 3.5c.042 0 .082-.009.123-.012v3.524c-.04-.003-.08-.012-.123-.012a1.75 1.75 0 1 0 0 3.5c.042 0 .082-.009.123-.012v1.295c-.791-.251-1.598-.502-2.369-.754a1.75 1.75 0 0 0-1.54-.504c-.641-.213-1.257-.425-1.884-.638a1.75 1.75 0 1 0-3.078-1.055c-1.426-.499-2.822-.998-4.222-1.496a1.75 1.75 0 0 0-.942-.334c-.71-.253-1.433-.507-2.146-.76a1.75 1.75 0 0 0-.43-2.422l-1.596 1.71c-1.047-.37-2.159-.738-3.23-1.106c5-5.346 9.953-10.706 14.318-15.797m5.06 1.84c-1.156.286-2.137.788-3.138 1.545a1.75 1.75 0 1 0 3.139-1.545m-4.421 2.656a46 46 0 0 0-2.268 2.277a1.75 1.75 0 1 0 2.268-2.277m-85.656 1.99c18.115 12.035 33.234 17 51.261 19.965c-3.805 4.23-7.139 8.16-9.572 11.578a11.8 11.8 0 0 0-5.324-1.28c-1.241 0-2.441.194-3.57.552c-7.314-14.554-19.964-21.79-32.795-29.356Zm88.5 1.387a1.75 1.75 0 1 0 .027 3.5a1.75 1.75 0 0 0-.027-3.5m-6.28.148l-2.256 2.416a1.75 1.75 0 1 0 2.256-2.416m2.78 3.352a1.75 1.75 0 1 0 .027 3.5a1.75 1.75 0 0 0-.027-3.5m-6.121.228l-2.323 2.489a1.75 1.75 0 1 0 2.323-2.489m2.62 3.272a1.75 1.75 0 1 0 .028 3.5a1.75 1.75 0 0 0-.027-3.5m7 0a1.75 1.75 0 1 0 .028 3.5a1.75 1.75 0 0 0-.027-3.5m-88.5 1.248c11.478 6.84 21.321 13.273 26.981 25.223c-1.607 2.038-2.578 4.597-2.578 7.37c0 3.318 1.382 6.333 3.592 8.509c-1.164 3.244-2.53 6.33-4.024 9.351h-4.328l2.75-4.762l-2.922-1.687l1.041-1.805l-4.047-2.336l-6.115 10.59H3.931V48.32l7.684 4.582l4.778-8.012l-12.461-7.432ZM63.58 44.437c2.32.385 4.57.922 6.73 1.57a1.75 1.75 0 1 0 2.84.927c1.369.483 2.69 1 3.97 1.54a1.75 1.75 0 0 0 1.415.61c.649.29 1.276.584 1.897.88a1.75 1.75 0 1 0 3.127 1.56c.693.363 1.29.708 1.935 1.064l-.058-.002a1.75 1.75 0 1 0 1.464.773c3.197 1.81 5.717 3.38 7.327 4.172a1.75 1.75 0 0 0 1.723 2.055c.042 0 .08-.015.122-.018v3.53c-.04-.003-.08-.012-.123-.012h-.013a1.75 1.75 0 0 0 .013 3.5c.042 0 .082-.009.123-.012v3.524c-.04-.003-.08-.012-.123-.012a1.75 1.75 0 1 0 0 3.5c.042 0 .082-.009.123-.012v9.713H61.15c-2.7-5.02-5.69-9.798-9.795-13.324a11.8 11.8 0 0 0-.613-10.328c2.623-3.807 7.38-9.234 12.834-15.198zm4.37 4.649c-.218 0-.434.04-.637.12a11.4 11.4 0 0 0-.092 3.22a1.75 1.75 0 1 0 .729-3.34m7 0a1.75 1.75 0 1 0 0 3.5a1.75 1.75 0 0 0 0-3.5m-56.749 3.307l-3.623 6.275l-2.431 4.21l6.275 3.624l2.432-4.211l2.492 1.44l3.623-6.276l-2.492-1.44zm53.235.193a1.75 1.75 0 1 0 .027 3.5a1.75 1.75 0 0 0-.027-3.5m7 0a1.75 1.75 0 1 0 .027 3.5a1.75 1.75 0 0 0-.027-3.5m-3.5 3.5a1.75 1.75 0 1 0 .027 3.5a1.75 1.75 0 0 0-.027-3.5m7 0a1.75 1.75 0 1 0 .027 3.5a1.75 1.75 0 0 0-.027-3.5m7 0a1.75 1.75 0 1 0 .027 3.5a1.75 1.75 0 0 0-.027-3.5m-20.713.021c.013.031.021.061.035.092a70 70 0 0 1-.139 3.377a1.75 1.75 0 0 0 .104-3.469m-27.922 2.856a6.434 6.434 0 0 0-6.463 6.465a6.43 6.43 0 0 0 6.463 6.463a6.434 6.434 0 0 0 6.465-6.463a6.435 6.435 0 0 0-6.465-6.465m31.135.623a1.75 1.75 0 1 0 .027 3.5a1.75 1.75 0 0 0-.027-3.5m7 0a1.75 1.75 0 1 0 .027 3.5a1.75 1.75 0 0 0-.027-3.5m7 0a1.75 1.75 0 1 0 .027 3.5a1.75 1.75 0 0 0-.027-3.5m7 0a1.75 1.75 0 1 0 .027 3.5a1.75 1.75 0 0 0-.027-3.5m-52.135.877c2.783 0 4.965 2.182 4.965 4.965s-2.182 4.963-4.965 4.963s-4.963-2.18-4.963-4.963s2.18-4.965 4.963-4.965m34.635 2.623a1.75 1.75 0 1 0 .027 3.5a1.75 1.75 0 0 0-.027-3.5m7 0a1.75 1.75 0 1 0 .027 3.5a1.75 1.75 0 0 0-.027-3.5m7 0a1.75 1.75 0 1 0 .027 3.5a1.75 1.75 0 0 0-.027-3.5m-20.694.023c.224.556.658.995 1.444 1.514a1.75 1.75 0 0 0-1.444-1.514m10.194 3.477a1.75 1.75 0 1 0 .027 3.5a1.75 1.75 0 0 0-.027-3.5m7 0a1.75 1.75 0 1 0 .027 3.5a1.75 1.75 0 0 0-.027-3.5m7 0a1.75 1.75 0 1 0 .027 3.5a1.75 1.75 0 0 0-.027-3.5M65.81 68.359c-3.228 0-5.877 2.65-5.877 5.877c0 3.228 2.65 5.875 5.877 5.875s5.875-2.647 5.875-5.875c0-3.227-2.648-5.877-5.875-5.877m16.134 1.727a1.75 1.75 0 0 0-1.271 2.953l2.562-.021a1.75 1.75 0 0 0-1.29-2.932m7 0a1.75 1.75 0 0 0-1.324 2.893l2.668-.024a1.75 1.75 0 0 0-1.344-2.87m-23.134 1.273a2.854 2.854 0 0 1 2.875 2.877a2.85 2.85 0 0 1-2.875 2.875a2.854 2.854 0 0 1-2.877-2.875a2.855 2.855 0 0 1 2.877-2.877m-18.913 4.02c2.168 1.932 4.174 4.707 6.118 7.908H35.65c.899-1.979 1.762-3.992 2.541-6.096c.686.124 1.387.2 2.106.2c2.433 0 4.704-.745 6.601-2.012"
              color="currentColor"
            />
          </svg>
          <span>{{ $t("Plans") }}</span>
        </router-link>
        <router-link to="/admin-projects">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            viewBox="0 0 24 24"
            class="mx-2"
          >
            <g fill="none" fill-rule="evenodd">
              <path
                d="m12.594 23.258l-.012.002l-.071.035l-.02.004l-.014-.004l-.071-.036q-.016-.004-.024.006l-.004.01l-.017.428l.005.02l.01.013l.104.074l.015.004l.012-.004l.104-.074l.012-.016l.004-.017l-.017-.427q-.004-.016-.016-.018m.264-.113l-.014.002l-.184.093l-.01.01l-.003.011l.018.43l.005.012l.008.008l.201.092q.019.005.029-.008l.004-.014l-.034-.614q-.005-.019-.02-.022m-.715.002a.02.02 0 0 0-.027.006l-.006.014l-.034.614q.001.018.017.024l.015-.002l.201-.093l.01-.008l.003-.011l.018-.43l-.003-.012l-.01-.01z"
              />
              <path
                fill="currentColor"
                d="M17 3.722v5.497l2.864.716A1.5 1.5 0 0 1 21 11.39V19a1 1 0 1 1 0 2H3a1 1 0 1 1 0-2v-7.69a1.5 1.5 0 0 1 .83-1.343L7 8.382V6.347a1.5 1.5 0 0 1 .973-1.405l7-2.625A1.5 1.5 0 0 1 17 3.722m0 7.559V19h2v-7.22zm-10-.663l-2 1V19h2z"
              />
            </g>
          </svg>
          <span>{{ $t("dashboard.projects") }}</span>
        </router-link>
        <router-link to="/admin-users">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="25"
            height="25"
            viewBox="0 0 24 24"
          >
            <path
              fill="currentColor"
              d="M16 17v2H2v-2s0-4 7-4s7 4 7 4m-3.5-9.5A3.5 3.5 0 1 0 9 11a3.5 3.5 0 0 0 3.5-3.5m3.44 5.5A5.32 5.32 0 0 1 18 17v2h4v-2s0-3.63-6.06-4M15 4a3.4 3.4 0 0 0-1.93.59a5 5 0 0 1 0 5.82A3.4 3.4 0 0 0 15 11a3.5 3.5 0 0 0 0-7"
            />
          </svg>
          <span>{{ $t("dashboard.users") }}</span>
        </router-link>
        <router-link to="/admin-news">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="25"
            height="25"
            viewBox="0 0 24 24"
          >
            <path
              fill="currentColor"
              d="M3 3a1 1 0 0 0-1 1v16a1 1 0 0 0 1 1h18a1 1 0 0 0 1-1V4a1 1 0 0 0-1-1zm3 4h6v6H6zm2 2v2h2V9zm10 0h-4V7h4zm-4 4v-2h4v2zm-8 4v-2h12v2z"
            />
          </svg>
          <span>{{ $t("dashboard.news") }}</span>
        </router-link>
        <router-link to="/" @click="Logout()">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="25"
            height="25"
            viewBox="0 0 24 24"
            class="mx-2"
          >
            <g fill="none">
              <path
                fill="currentColor"
                fill-rule="evenodd"
                d="M10.138 1.815A3 3 0 0 1 14 4.688v14.624a3 3 0 0 1-3.862 2.873l-6-1.8A3 3 0 0 1 2 17.512V6.488a3 3 0 0 1 2.138-2.873zM15 4a1 1 0 0 1 1-1h3a3 3 0 0 1 3 3v1a1 1 0 1 1-2 0V6a1 1 0 0 0-1-1h-3a1 1 0 0 1-1-1m6 12a1 1 0 0 1 1 1v1a3 3 0 0 1-3 3h-3a1 1 0 1 1 0-2h3a1 1 0 0 0 1-1v-1a1 1 0 0 1 1-1M9 11a1 1 0 1 0 0 2h.001a1 1 0 1 0 0-2z"
                clip-rule="evenodd"
              />
              <path
                stroke="currentColor"
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="2"
                d="M16 12h5m0 0l-2-2m2 2l-2 2"
              />
            </g>
          </svg>
          <span>{{ $t("Navbar.LogOut") }}</span>
        </router-link>
      </div>
      <div class="left-side">
        <slot></slot>
      </div>
    </div>
  </div>
</template>

<script>
import store from "@/store";
import router from "@/router";
export default {
  name: "side-bar",
  methods: {
    Logout() {
      store.state.token = "";
      store.state.role = "";
      window.sessionStorage.removeItem("token");
      window.sessionStorage.removeItem("role");
      location.reload;
    },
    hideLoadingScreen() {
      store.commit("hideLoadingScreen");
    },
  },
  mounted() {
    if (store.state.role != "admin") {
      router.push("/");
    }
    this.hideLoadingScreen();
  },
};
</script>

<style scoped lang="scss">
a {
  font-weight: bold;
  color: #d3b37d;
  text-decoration: none;
  width: 100%;
  height: 50px;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 18px;
  &.router-link-exact-active {
    text-decoration: none;
    background-color: #d3b37d;
    color: whitesmoke;
  }
  transition: 0.5s ease-in-out;
}

a:hover {
  color: whitesmoke;
  background-color: #d3b37d;
}

.full-content {
  height: 90dvh;
  width: 100dvw;
  display: flex;
  justify-content: center;
  align-items: center;
}
.right-side {
  height: 100%;
  width: 25%;
  background-color: whitesmoke;
  display: flex;
  flex-direction: column;
  justify-content: start;
  align-items: center;
}
.left-side {
  height: 100%;
  width: 75%;
  overflow-y: scroll;
}
@media screen and (max-width: 720px) {
  a > span {
    display: none;
  }
}
</style>
